import { createApp } from 'vue'
import App from './App.vue'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './utils/iconfont.css'
import router from "./router"

import 'amfe-flexible'
import VueLazyLoad from 'vue3-lazyload'

createApp(App)
  .use(router)
  .use(ElementPlus)
  .use(VueLazyLoad)
  .mount('#app')